import React from 'react';
import { AreaChart, Card, Title, Text, Flex, BadgeDelta, Grid } from '@tremor/react';
import { ResponsiveBar } from '@nivo/bar';
import { ResponsivePie } from '@nivo/pie';

// --- Tremor Components ---

export const RiskScoreTrendTremor = ({ data, height = 300 }) => {
    // Format data for Tremor
    const chartData = data.map(d => ({
        date: d.date instanceof Date ? d.date.toLocaleDateString() : d.date,
        "Risk Score": d.riskScore
    }));

    return (
        <div className="w-full" style={{ height }}>
            <AreaChart
                className="h-full mt-4"
                data={chartData}
                index="date"
                categories={["Risk Score"]}
                colors={["teal"]}
                valueFormatter={(number) => `${Math.round(number)}%`}
                yAxisDomain={[0, 100]}
                showAnimation={true}
                showLegend={false}
                showGridLines={true}
                curveType="monotone"
            />
        </div>
    );
};

export const SeverityTrendTremor = ({ data, height = 300 }) => {
    // Format data for Tremor
    const chartData = data.map(d => ({
        date: d.date instanceof Date ? d.date.toLocaleDateString() : d.date,
        "Critical": d.severities?.critical || 0,
        "Serious": d.severities?.serious || 0,
        "Moderate": d.severities?.moderate || 0,
        "Minor": d.severities?.minor || 0,
    }));

    return (
        <div className="w-full" style={{ height }}>
            <AreaChart
                className="h-full mt-4"
                data={chartData}
                index="date"
                categories={["Critical", "Serious", "Moderate", "Minor"]}
                colors={["red", "orange", "yellow", "teal"]}
                valueFormatter={(number) => `${number}`}
                showAnimation={true}
                stack={true}
                curveType="monotone"
            />
        </div>
    );
};

// --- Nivo Components ---

export const WcagCriteriaBreakdownNivo = ({ data }) => {
    // data format: [{ criteria: 'Contrast', count: 12 }, ...]
    if (!data || data.length === 0) {
        return (
            <div className="h-80 w-full flex items-center justify-center border-2 border-dashed border-espresso/10 rounded-2xl bg-stone/5">
                <p className="text-[0.625rem] font-bold uppercase tracking-widest text-espresso/40">No violation data available</p>
            </div>
        );
    }
    return (
        <div className="h-80 w-full">
            <ResponsiveBar
                data={data}
                keys={['count']}
                indexBy="criteria"
                margin={{ top: 20, right: 30, bottom: 50, left: 160 }}
                padding={0.3}
                layout="horizontal"
                valueScale={{ type: 'linear' }}
                indexScale={{ type: 'band', round: true }}
                colors={{ scheme: 'nivo' }}
                borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
                axisTop={null}
                axisRight={null}
                axisBottom={{
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legend: 'Violation Count',
                    legendPosition: 'middle',
                    legendOffset: 32
                }}
                axisLeft={{
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legend: '',
                    legendPosition: 'middle',
                    legendOffset: -140
                }}
                labelSkipWidth={12}
                labelSkipHeight={12}
                labelTextColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
                animate={true}
                motionStiffness={90}
                motionDamping={15}
            />
        </div>
    );
};

export const ImpactPieChartNivo = ({ data }) => {
    // data format: [{ id: 'critical', label: 'Critical', value: 10, color: '#...' }, ...]
    if (!data || data.length === 0 || data.every(d => d.value === 0)) {
        return (
            <div className="h-80 w-full flex items-center justify-center border-2 border-dashed border-espresso/10 rounded-2xl bg-stone/5">
                <p className="text-[0.625rem] font-bold uppercase tracking-widest text-espresso/40">No impact data available</p>
            </div>
        );
    }
    return (
        <div className="h-80 w-full">
            <ResponsivePie
                data={data}
                margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
                innerRadius={0.6}
                padAngle={0.7}
                cornerRadius={3}
                activeOuterRadiusOffset={8}
                borderWidth={1}
                borderColor={{ from: 'color', modifiers: [['darker', 0.2]] }}
                arcLinkLabelsSkipAngle={10}
                arcLinkLabelsTextColor="#333333"
                arcLinkLabelsThickness={2}
                arcLinkLabelsColor={{ from: 'color' }}
                arcLabelsSkipAngle={10}
                arcLabelsTextColor={{ from: 'color', modifiers: [['darker', 2]] }}
                colors={{ datum: 'data.color' }}
                legends={[
                    {
                        anchor: 'bottom',
                        direction: 'row',
                        justify: false,
                        translateX: 0,
                        translateY: 56,
                        itemsSpacing: 0,
                        itemWidth: 100,
                        itemHeight: 18,
                        itemTextColor: '#999',
                        itemDirection: 'left-to-right',
                        itemOpacity: 1,
                        symbolSize: 18,
                        symbolShape: 'circle',
                        effects: [
                            {
                                on: 'hover',
                                style: {
                                    itemTextColor: '#000'
                                }
                            }
                        ]
                    }
                ]}
            />
        </div>
    );
};
